import { gridDefaults } from "@serenity-is/sleekgrid";
import { EnhancedLayout } from "../GridMixins/EnhancedLayout";

gridDefaults.layoutEngine = () => new EnhancedLayout();